
import { Options, Vue } from "vue-property-decorator";
@Options({
  name: "Personmanage",
})
export default class extends Vue {}
